export default {
  PageFacturae: {
    // Headers and titles
    rectificative_invoice_title: 'FACTURA RECTIFICATIVA',
    rectifies_invoice: 'Rectifica la factura {invoiceNumber} del {invoiceDate}',
    draft_watermark: 'BORRADOR',

    // QR and verification
    qr_label: 'QR tributario:',
    qr_verifiable: 'Factura verificable en la sede electrónica de la AEAT',

    // Invoice numbers and dates
    invoice_number_label: 'Número {documentType}: ',
    external_invoice_number: 'Número factura externo: ',
    invoice_date_label: 'Fecha {documentType}: ',
    due_date: 'Fecha vencimiento: ',
    operation_date: 'Fecha operación: ',
    start_date: 'Fecha inicio: ',
    end_date: 'Fecha final: ',
    signing_date: 'Fecha firma: ',

    // Supplier section
    issuer: 'Emisor',
    business_name: 'Razón social: ',
    fiscal_name: 'Nombre fiscal: ',
    fiscal_address: 'Domicilio fiscal: ',
    nif_cif: 'NIF/CIF: ',
    bank_account: 'Número de cuenta: ',
    trade_name: 'Nombre Comercial: ',
    email_label: 'Email: ',
    phone_label: 'Teléfono:',
    website_label: 'Web:',

    // Customer section
    receiver: 'Receptor',
    dire_label: 'DIRe:',
    accounting_office: 'Despacho contable:',
    management_body: 'Órgano de gestión:',
    processing_unit: 'Unidad tramitadora:',
    proposing_body: 'Órgano proponente:',

    // Details section
    details: 'Detalles',
    details_of_budget: 'del presupuesto',
    details_of_delivery_note: 'del albarán',
    details_of_proforma: 'de la proforma',
    details_of_ticket: 'del ticket',
    details_of_invoice: 'de la factura',

    // Table headers
    description: 'Descripción',
    total: 'Total',
    quantity: 'Cantidad',
    unit_price: 'Precio unitario',
    discount_percentage: 'Descuento %',
    withholding: 'Retención',
    total_without_tax: 'Total (sin IVA/IGIC)',

    // Document type headers
    proforma_label: 'Proforma',
    budget_label: 'Presupuesto',
    delivery_note_label: 'Albarán',
    date_of_proforma: 'Fecha de la proforma: ',
    date_of_budget: 'Fecha del presupuesto: ',
    date_of_delivery_note: 'Fecha del albarán: ',
    file_reference: 'Expediente',
    file_date: 'Fecha del expediente: ',
    client_reference: 'Referencia Cliente',

    // Totals section
    total_without_discounts: 'Total sin descuentos',
    line_discount: 'Descuento por línea',
    global_discount: 'Descuento global',
    total_without_taxes: 'Total sin impuestos',
    total_withholding: 'Total Retención',
    total_document: 'Total {documentType}',
    withholding_label: 'Retención: ',
    reimbursable_label: 'Suplido: ',
    total_to_pay: 'Total a pagar',

    // Document types for dynamic text
    invoice: 'Factura',
    budget: 'Presupuesto',
    delivery_note: 'Albarán',
    proforma: 'Proforma',
    ticket: 'Ticket',

    // Footer
    page_number: 'Página {currentPage} de {totalPages}',
    document_info: 'Núm. {documentType}: {invoiceNumber} ({invoiceDate})',
  }
}